module.exports = __webpack_public_path__ + "static/Providers-aadd2625cf288815d6674aad5da96f7b.jpg";